import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Stack, Typography } from "@mui/material";

export default function StartOverBackDrop() {
  return (
    <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={true}
      >
        <Stack alignItems={"center"}>
          <Typography> Starting Over... </Typography>
          <CircularProgress color="inherit" />
        </Stack>
      </Backdrop>
    </div>
  );
}
